// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import imageUserCheckIcon from "@/assets/icons/image-user-check.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ImageUserCheckIconProps = Omit<IconProps, "name">;

export function ImageUserCheckIcon(props: ImageUserCheckIconProps): React.ReactNode {
  return <Icon name={imageUserCheckIcon} {...props} />;
}
